import React from 'react';
import moment from 'moment';

import {
  bool, func, shape, string,
} from 'prop-types';
import { clone, remove } from 'lodash';
import { useMutation } from '@apollo/client';
import ClampLines from './ClampLines';

import {
  Column,
  ColumnText,
  DismissButton,
  Grid,
  Icon,
  Row,
} from './styles';
import { DISMISS_APPROVAL, GET_APPROVALS, LIMIT } from '../../graphql';

const Header = (props) => {
  const {
    content,
    expanded,
    onExpandButtonClicked,
    approvalType,
    projectId,
    participantsSource,
    refetch,
  } = props;

  const handleMutationUpdate = (cache, { data: { dismissApproval } }) => {
    const { approvals: cachedApprovals } = cache.readQuery({
      query: GET_APPROVALS,
      variables: {
        limit: LIMIT,
        offset: 0,
        participantSource: [participantsSource],
      },
    });

    const { approvalType: approvalTypeDismiss, projectId: projectIdDismissApproval } = dismissApproval;

    const newApprovals = cachedApprovals.map((cachedApproval) => {
      if (cachedApproval.project.id === projectIdDismissApproval) {
        const newTypes = clone(cachedApproval.approvalTypes);
        remove(
          newTypes,
          (cachedApprovalType) => cachedApprovalType === approvalTypeDismiss,
        );
        return {
          project: cachedApproval.project,
          approvalTypes: newTypes,
        };
      }
      return cachedApproval;
    });

    cache.writeQuery({
      query: GET_APPROVALS,
      data: {
        approvals: newApprovals,
      },
    });
  };

  const [dismissApproval, { loading }] = useMutation(DISMISS_APPROVAL, {
    update: handleMutationUpdate,
    onCompleted: refetch,
  });

  return (
    <Grid columns={5}>
      <Row onClick={onExpandButtonClicked}>
        <Column width={3}>
          <ColumnText>
            {content.approvalType}
          </ColumnText>
        </Column>
        <Column width={3}>
          <ColumnText>
            <ClampLines
              label={content.company}
            />
          </ColumnText>
        </Column>
        <Column width={3}>
          <ColumnText>
            <ClampLines
              label={content.projectName}
            />
          </ColumnText>
        </Column>
        <Column width={3}>
          <ColumnText>
            {content.launchedOn ? moment(content.launchedOn).format('MM/DD/YYYY') : moment(content.createdOn).format('MM/DD/YYYY')}
          </ColumnText>
        </Column>
        <Column width={3}>
          <DismissButton
            onClick={() => dismissApproval({
              variables: {
                projectId,
                approvalType,
              },
            })}
            loading={loading}
          >
            Dismiss
          </DismissButton>
        </Column>
        <Column width={1}>
          <Icon
            size="small"
            name={expanded ? 'chevron up' : 'chevron down'}
          />
        </Column>
      </Row>
    </Grid>
  );
};

Header.propTypes = {
  content: shape({
    approvalType: string,
    company: string,
    projectName: string,
    createdOn: string,
    launchedOn: string,
  }).isRequired,
  expanded: bool,
  onExpandButtonClicked: func.isRequired,
  approvalType: string.isRequired,
  projectId: string.isRequired,
  participantsSource: string.isRequired,
  refetch: func.isRequired,
};

Header.defaultProps = {
  expanded: false,
};

export default Header;
